import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=39ae709d&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ae709d')) {
      api.createRecord('39ae709d', component.options)
    } else {
      api.reload('39ae709d', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=39ae709d&", function () {
      api.rerender('39ae709d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CiEb1gCe2OFD/JS/childrenage.vue"
export default component.exports